
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import ProjectFinder2Home from '../ProjectFinder2/ProjectFinder2Home';
import ProjectFinderHomeLM from '../ProjectFinder2/ProjectFinderHomeLM';
import EvBookingAgenda from '../EventFinder/EvBookingAgenda';
import MonthColumnPlanMinimalMode from '../MonthColumnPlan_TS/MonthColumnPlanMinimalMode/MonthColumnPlanMinimalMode';
import EventFinderLM from '../EventFinder/EventFinderLM';
import MonthColumnTabbed from '../MonthColumnPlan_TS/MonthColumnTabbed/MonthColumnTabbed';
import WidgetNavigationMap from '../../moreCore/UI/Navigation/WidgetNavigationMap';
import { FeatureHelpers, TranslationHelpers } from "../../more/Helpers";
import DistributionChannelKanban from '../EvBooking/DistributionChannels/DistributionChannelKanban';
import BudgetRoster from '../CostCalculation/BudgetRoster';
import EvBookingOverviewFinder from '../EventFinder/EvBookingOverviewFinder/EvBookingOverviewFinder';



/**
 * Home-Navigation für Orchesterdienste-Bereich
 */


interface groupSettings {
    
    icon: string
}
class PlanningNavigation extends compose(WidgetNavigationMap<{}>) {

    //BASE
    postCreate(): void {

        this.layoutConfig["compact"].selectable = false;
        super.postCreate.apply(this, arguments as any);

        if (FeatureHelpers.hasFeature("Planning/WebsiteExport")) {
            this.requestContextButton({
                callback: lang.hitch(this, this._onClickExportWebsiteData),
                label: this.translate("Planning_Label_ExportWebsiteData"),
                permanent: true,
                enabled: true,
                name: "exportWebsiteData",
                iconClass: "fas fa-globe",
                placement: "topmenu"
            })
        }

    }

    private _onClickExportWebsiteData() {
        this.RequestManager.callfunction("Webtool_API__ProjectWizard_ExportWebsiteData", {}, lang.hitch(this, this._onExportWebsiteDataResponse), lang.hitch(this, this._onExportWebsiteDataError));
    }

    private _onExportWebsiteDataResponse(response) {
        this.showToast(this.translate("Planning_Message_SuccessfulExport"), "fas fa-check");
    }

    private _onExportWebsiteDataError(error) {
        this.showToast(error, "fas fa-times");
    }
    
    startup(): void {
        super.startup.apply(this, arguments as any);
        
        let module = FeatureHelpers.getModule<{ "defaultOpen": Array<string> }>("Planning");
        let defaultOpen = module?.defaultOpen ? module.defaultOpen : ["ProjectFinder"];
        
        this.setup({"ProjectFinder": {
                navigationAreaName: "General_Label_EvProjects",
                icon: "fas fa-clipboard",
                label: "Projects__Search",
                colorClass: "w3-2018-arcadia",
            roles: ["Projects_Read"],
            openByDefault: defaultOpen.indexOf("ProjectFinder") != -1,
            order: 1,
                //featurepath: "OrchestraEmployment/SelfCheckin",
                targetWidget: ProjectFinder2Home

            },

            "ProjectFinderLM": {
                navigationAreaName: "General_Label_EvProjects",
                icon: "fas fa-history",
                label: this.stringFormat("{0} - {1}",
                    TranslationHelpers.translate("General_Label_EvProjects"),
                    TranslationHelpers.translate("General_LastModified")),
                    order: 99,
                colorClass: "sD2",
                roles: ["Projects_Read"],
                //featurepath: "OrchestraEmployment/SelfCheckin",
                targetWidget: ProjectFinderHomeLM,
            openByDefault: defaultOpen.indexOf("ProjectFinderLM") != -1,
            },

            "DistributionChannelKanban": {
                navigationAreaName: "General_Label_EvBookings",
                icon: "fas fa-chart-pie", // fas fa-bullhorn
                label: "DistributionChannelKanban_MainTitle",
                order: 10,
                colorClass: "w3-2018-little-boy-blue",
                roles: ["EvBooking_DistributionChannelKanban"],
                featurepath: "Planning/DistributionChannelKanban",
                targetWidget: DistributionChannelKanban,
                openByDefault: defaultOpen.indexOf("DistributionChannelKanban") != -1

            },
            "BudgetCalculationRoster": {
                navigationAreaName: "General_Label_EvBookings",
                icon: "fas fa-euro-sign", // fas fa-bullhorn
                label: "BudgetCalculationRoster_MainTitle",
                order: 15,
                colorClass: "w3-orange",
                roles: ["BudgetCalculationRoster"],
                featurepath: "Planning/BudgetCalculationRoster",
                targetWidget: BudgetRoster,
                //openInDlg: "bigger",
                openByDefault: defaultOpen.indexOf("BudgetCalculationRoster") != -1

            },

            "EvBookingAgenda": {
                navigationAreaName: "General_Label_EvBookings",
                icon: "fas fa-calendar-alt",
                label: "EvBooking_AgendaMainTitle",
                order:50,
                colorClass: "w3-2018-little-boy-blue",
                roles: ["EvBooking_Read"],
                featurepath: "Planning/EvBookingAgenda",
                dojoProps: [{ name: "widgetTemplateVariant", value: "datepickerTopLeft"}],
                targetWidget: EvBookingAgenda,
                openByDefault: defaultOpen.indexOf("EvBookingAgenda") != -1

            },

            "EvBookingOverviewFinder": {
                navigationAreaName: "General_Label_EvBookings",
                icon: "fas fa-list-alt",
                label: "EvBooking_EvBookingOverviewFinderTitle",
                order:60,
                colorClass: "w3-2018-little-boy-blue",
                roles: ["EvBooking_Read"],
                featurepath: "Planning/EvBookingOverviewFinder",
                targetWidget: EvBookingOverviewFinder,
                openByDefault: defaultOpen.indexOf("EvBookingOverviewFinder") != -1
            },



            "EvBookingMCP": {
                navigationAreaName: "General_Label_EvBookings",
                icon: "fas fa-columns",
                label: "EvBooking_AgendaMainTitle_MonthColumnPlan",
                order:70,
                colorClass: "w3-2018-nebulas-blue",
                roles: ["EvBooking_Read", "MonthColumnPlan"],
                featurepath: "MonthColumnPlaner/minimalModeAgendaView",
                targetWidget: MonthColumnPlanMinimalMode
            },
            "EvBookingTerminoflex": {
                navigationAreaName: "General_Label_EvBookings",
                icon: "fas fa-columns",
                label: "NavigationTile__MonthColumnPlan",
                order:80,
                colorClass: "w3-2018-sailor-blue",
                roles: ["EvBooking_Read", "MonthColumnPlan"],
                featurepath: "MonthColumnPlaner/monthColumnPlanerAsTabInPlanning",
                targetWidget: MonthColumnTabbed
            },
            "EvBookingLM": {
                navigationAreaName: "General_Label_EvBookings",
                icon: "fas fa-history",
                label: this.stringFormat("{0} - {1}",
                    TranslationHelpers.translate("General_Label_EvBookings"),
                    TranslationHelpers.translate("General_LastModified")),
                order: 99,
                colorClass: "sD2",
                roles: ["EvBooking_Read"],
                featurepath: "Planning/EventFinderLM",
                targetWidget: EventFinderLM,
                openByDefault: defaultOpen.indexOf("EventFinderLM") != -1
            }
        }, null, "order");

    }
}

export default mdsWidget(PlanningNavigation);